import { useMemo } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";

import { getUsersCollection } from "integrations/firebase/collections";
import {
  isRunningInMeticulous,
  METICULOUS_USER_DATA,
} from "integrations/meticulous";

export const useUser = (userId?: string) => {
  const isMeticulous = isRunningInMeticulous();
  const [snapshot, loading, error] = useDocument(
    userId && !isMeticulous ? doc(getUsersCollection(), userId) : null,
  );

  return useMemo(() => {
    if (isMeticulous) {
      return { data: METICULOUS_USER_DATA, loading: false, error: undefined };
    }

    // When the id changes, the hook reports the previous snapshot as loaded
    // for one render, so a snapshot for another id still counts as loading.
    const isCurrent = snapshot?.id === userId;

    return {
      data: isCurrent ? snapshot?.data() : undefined,
      loading: loading || (Boolean(userId) && !isCurrent && !error),
      error,
    };
  }, [isMeticulous, snapshot, loading, error, userId]);
};
